import Link from "@/components/ui/Link";
import { LinkStoryblok } from "@/generated/sb/sb-types";
import { getLink } from "@frend-digital/storyblok";

export const LinkBlok = ({
  blok,
  className,
  ...rest
}: {
  blok: LinkStoryblok;
  className?: string;
}) => {
  const text = blok.text;
  const href = getLink(blok.link)?.href;

  return (
    <Link {...rest} className={className} href={href ?? ""}>
      {text}
    </Link>
  );
};
